import { FlowPatch, FunnelFlowConfig, quiz, screen } from './flow/flow-config';

const screens = [
  quiz('age'),
  quiz('gender'),
  quiz('goals'),
  quiz('amountInfo'),
  quiz('audioExperience'),
  quiz('goalMotivations'),
  quiz('goalInfo'),

  quiz('personType'),
  quiz('personTypeInfo'),

  quiz('anxiety'),
  quiz('procrastination'),

  quiz('honest'),

  quiz('timeForReading'),

  quiz('audioCustomizationInfo'),
  screen('customization'),

  quiz('visionCare'),
  quiz('visionCareInfo', { skipIf: { step: 'visionCare', is: ['allGood'] } }),

  quiz('retention'),
  quiz('technology'),
  quiz('audioExperienceInfo'),

  quiz('format'),
  screen('formatInput', { showIf: { step: 'format', is: ['other'] } }),

  quiz('time'),

  quiz('celeb1'),
  quiz('celeb2'),
  quiz('celeb3'),

  quiz('demo1'),
  quiz('demo2'),
  quiz('yourBook'),

  quiz('investmentTime'),

  quiz('prediction'),
  screen('ready'),
  screen('login'),

  quiz('result'),
  screen('paywall'),
];

// Book covers in place of the text demos. An ad's promoted book (`?book=`) is promised as the
// first book sample, so those visitors keep the covers.
export const bookSamplePatches: readonly FlowPatch[] = [
  { replace: 'demo1', with: [quiz('book1')] },
  { replace: 'demo2', with: [quiz('book2')] },
];

export const funnelFlow: FunnelFlowConfig = {
  screens,
  promotedBookPatches: bookSamplePatches,
  experiments: [
    {
      experiment: 'funnel_first_screen_nov_2026',
      property: 'web_ab_funnel_first_screen',
      // The yes/no question opens the funnel, age moves to second and gender goes, so both cells
      // run the same number of steps. Gender then stays unset, which every reader of it already
      // tolerates (amountInfo falls back to its generic count).
      cells: {
        readingToAudio: [
          { replace: 'age', with: [quiz('readingToAudio'), quiz('age')] },
          { replace: 'gender', with: [] },
        ],
      },
    },
  ],
};
